module.exports = __webpack_public_path__ + "img/bg10.5e0565b9.png";